/* global window */

import diff from 'deep-diff';
import deepCopy from 'deep-copy';
import {safeJSONparse} from "../../common/util/safeJSONparse";

export const MAX_APPLICATION_SELECTED = 30;

export const APPLICATIONS_URL_HANDLE = 'applications';
export const SCENARIOS_GEERAL_LIMIT = 9;
export const SCENARIOS_SELECTED_LIMIT = 100;

export function getApplicationsFromUrl() {
    let searchQuery;

    // in case of generating public pages, there are no window.location context
    try {
        searchQuery = window.location.search;
    }
    catch (e) {
        return null;
    }

    if (searchQuery) {
        let applicationsIndex = searchQuery.indexOf(APPLICATIONS_URL_HANDLE + '=[');

        if (-1 !== applicationsIndex) {
            let substr = searchQuery.substring(applicationsIndex + (APPLICATIONS_URL_HANDLE + '=[').length);
            substr = substr.substring(0, substr.indexOf(']'));

            if (substr.length === 0) {
                return null;
            }

            return substr.split(',');
        }
    }

    return null;
}

let applicationObserverListeners = [];
export class ApplicationObserver {
    static subscribe(fn) {
        if (!applicationObserverListeners.includes(fn)) {
            applicationObserverListeners.push(fn);
        }
    }

    static unsubscribe(fn) {
        let index = applicationObserverListeners.indexOf(fn);

        if (-1 !== index) {
            applicationObserverListeners.splice(index, 1);
        }
    }

    static notifyAll(newValue) {
        applicationObserverListeners.forEach(fn => {
            fn(newValue);
        });
    }
}

let selected = [];
let applicationList = [];
let elCache = {};
let badgeEl;
let clearAllEl;
export function onInit() {
    generateApplicationList();
    bindApplicationOnClick();
    let initSelected = getSelectedFromUrl();
    selectedChange(initSelected);
    startListenOnHistoryChange();

    if (initSelected.length >= 2) {
        getClearAllEl().classList.remove('hidden');
    }
}
export function startListenOnHistoryChange() {
    window.addEventListener('popstate', () => {
        if (window.history.state && window.history.state.selected) {
            selected
                .forEach((app) => {
                    removeSelectApplication(app);
                    removeBadge(app, window.history.state.selected.length);
                });

            selected = [];
            elCache = {};
            badgeEl = null;
            clearAllEl = null;
            selectedChange(window.history.state.selected);
        }
    }, false);
}
export function generateApplicationList(selectedList) {
    Array.prototype.slice.call(document.querySelectorAll('.applicationBox > .applicationBoxItem')).forEach((applicationEl) => {
        let application = safeJSONparse(applicationEl.getAttribute('data-application'));
        applicationList.push(application);
    });
}
export function bindApplicationOnClick() {
    let inputSearchEl = document.getElementById('fulltextApplicationSearch');

    applicationList.forEach((app) => {
        document.querySelectorAll('#app' + app.urlFragment).forEach((applicationEl) => {
            applicationEl.onclick = (event) => {
                selectToggle(app);

                if (inputSearchEl) {
                    inputSearchEl.select();
                    inputSearchEl.focus();
                }

                return false;
            };

            applicationEl.onkeydown = (event) => {
                if (event.keyCode === 32) {
                    applicationEl.onclick.apply(applicationEl);
                }
                event.preventDefault();
                event.stopPropagation();

                return false;
            };
        });
    });
}
export function initSearchEl() {
    let inputSearchEl = document.getElementById('fulltextApplicationSearch');

    inputSearchEl.onfocus = (event) => {
        inputSearchEl.focus();
    };
}
export function getSelectedFromUrl() {
    let fragments = getSelectedFragnents();

    if (fragments) {
        return fragments.map((applicationFragment) => {
            return applicationList.find((app) => {
                return app.urlFragment === applicationFragment;
            });
        });
    }

    return [];
}
export function getSelectedFragnents() {
    // generated web doesn't have window reference
    if (typeof (window) === 'undefined') {
        return null;
    }
    let query = window.location.search;

    if (query) {
        let splitted = query.split('/');
        let applicationsFragments = splitted.slice(2, splitted.length - 1);

        return applicationsFragments;
    }

    return null;
}
export function selectedChange(list = []) {
    let newList = deepCopy(list);

    if (diff(selected, list)) {
        ApplicationObserver.notifyAll(list);
    }

    selected
        .filter(el => !newList.includes(el))
        .forEach((app) => {
            removeSelectApplication(app);
            removeBadge(app, list.length);
        });

    newList
        .filter(el => !selected.includes(el))
        .forEach((app) => {
            addSelectApplication(app);
            addBadge(app, list.length);
        });

    selected = list;
}
export function getSelected() {
    return selected;
}

export function getAppEl(app) {
    if (!elCache[app.urlFragment]) {
        elCache[app.urlFragment] = document.querySelectorAll('#app' + app.urlFragment);
    }

    return elCache[app.urlFragment];
}
export function clearCache() {
    elCache = {};
}
export function addSelectApplication(app) {
    getAppEl(app).forEach(el => el.classList.add('selected'));
}
export function removeSelectApplication(app) {
    getAppEl(app).forEach(el => el.classList.remove('selected'));
}
export function selectToggle(application) {
    let currentSelection = deepCopy(selected);

    let selectedIndex = currentSelection.findIndex((app) => {
        return app.urlFragment === application.urlFragment;
    });

    if (-1 === selectedIndex) {
        currentSelection.push(application);
    }
    else {
        currentSelection.splice(selectedIndex, 1);
    }

    let path = window.location.origin + window.location.pathname;

    if (currentSelection.length) {
        path += '?/' + APPLICATIONS_URL_HANDLE + '/' + currentSelection.map(app => app.urlFragment + '/').join('');
    }

    window.history.pushState(
        {selected: currentSelection},
        'Scenarios finder',
        path
    );

    selectedChange(currentSelection);
}

export function getBadgeEl() {
    if (!badgeEl) {
        badgeEl = document.getElementById('badgeList');
    }
    return badgeEl;
}
export function getClearAllEl() {
    if (!clearAllEl) {
        clearAllEl = document.getElementById('badgeClearAll');

        if (clearAllEl) {
            clearAllEl.onclick = () => {
                window.history.pushState(
                    {selected: []},
                    'Scenarios finder',
                    window.location.origin + window.location.pathname
                );

                selectedChange([]);
            };
        }
        else {
            return document.createElement("div");
        }
    }
    return clearAllEl;
}
export function addBadge(app, newSelectCnt) {
    let newBadge = renderBadge(app);
    getBadgeEl().insertBefore(newBadge, getBadgeEl().firstElementChild);

    if (newSelectCnt >= 2) {
        getClearAllEl().classList.remove('hidden');
    }
}
export function removeBadge(app, newSelectCnt) {
    let badgeEl = document.getElementById('badge' + app.urlFragment);
    if (badgeEl) {
        badgeEl.parentElement.removeChild(badgeEl);
    }

    if (newSelectCnt < 2) {
        getClearAllEl().classList.add('hidden');
    }
}
export function renderBadge(selectedApp) {
    let parser = new DOMParser();
    let html = parser.parseFromString('<span id="badge' + selectedApp.urlFragment + '" class="selectedAppBadge badge"><a class="removeSelectedApp"><i class="fa fa-times"></i></a><span class="name">' + selectedApp.name + '</span></span>', "text/html");

    html.body.querySelector('.removeSelectedApp').onclick = () => {
        selectToggle(selectedApp);
        return false;
    };

    return html.body.firstElementChild;
}

let searchName = '';
let searchCategory = 'allCategories';
let delayTimeout = null;
export function onSearchChangeDelay() {
    return new Promise((resolve) => {
        /* wait 250 ms after last change */
        if (delayTimeout) {
            clearTimeout(delayTimeout);
        }

        delayTimeout = setTimeout(() => {
            resolve();
        }, 250);
    });
}
export function initApplicationFilter() {
    let fulltextSearchEl = document.getElementById('fulltextApplicationSearch');

    if (fulltextSearchEl) {
        fulltextSearchEl.oninput = (event) => {
            searchName = event.target.value;

            onSearchChangeDelay().then(() => {
                filterApplications();
            }).catch(() => {});
        };
    }

    let categorySearchEl = document.getElementById('categoryApplicationSearch');
    if (categorySearchEl) {
        categorySearchEl.onchange = (event) => {
            searchCategory = event.target.value;
            filterApplications();

            if (searchCategory === 'allCategories') {
                categorySearchEl.classList.add('categorySearchEl');
            }
            else {
                categorySearchEl.classList.remove('categorySearchEl');
            }
        };
    }
}
export function filterApplications() {
    let searchRegExp = new RegExp('^.*' + searchName.toLowerCase().split('').join('.*') + '.*$');

    applicationList.forEach((app) => {
        let matched = true;

        if (searchCategory !== 'allCategories') {
            matched &= app.tags.some(tag => tag === searchCategory);
        }

        if (searchName !== '') {
            matched &= Boolean(app.name.toLowerCase().match(searchRegExp));
        }

        if (matched) {
            getAppEl(app).forEach(el => el.classList.remove('hidden'));
        }
        else {
            getAppEl(app).forEach(el => el.classList.add('hidden'));
        }
    });
}
